import React from 'react';
import PropTypes from 'prop-types';
import { GAME_TYPE } from '../../../../services/utilityFunctions';
import JourneyProgress from '../JourneyProgress';
import JourneyStepProp from '../../propTypes/journeyStepProp';

export default function JourneyCarouselProgress({ step, active }) {
  const isCandidates =
    step.game &&
    step.game.gameType &&
    step.game.gameType.type === GAME_TYPE.CANDIDATES;

  return (
    <div className="journey-progress-container">
      {isCandidates ? (
        <div>{`${step.game.candidates || 0} | 6`}</div>
      ) : (
        <JourneyProgress
          hideLabel
          progress={step.progress}
          height="4px"
          active={active}
        />
      )}
    </div>
  );
}

JourneyCarouselProgress.propTypes = {
  active: PropTypes.bool.isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
};
